<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Reports" subtitle="Manage the reports received for games after being checked out." :readonly="$authorised('con/checkout/access', 'read')">

		<app-content-head-actions-panel v-if="collection.length" text="Export" icon="export" component="manager/common/panel/Export" :data="importexportData" />

		<app-content-head-actions-item text="Add" icon="create" v-on:click="onCreateClick" />
		
	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />

		<app-content-filters-date mode="datetime" v-model="filter.from" tooltip="Filter from date" text="From" :max="filter.to" />

		<app-content-filters-date mode="datetime" v-model="filter.to" tooltip="Filter to date" text="To" :min="filter.from" />

		<app-content-filters-tags v-model="filter.status" :options="filterStatus" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no reports found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column />
				
				<app-table-column text="Game" />
				
				<app-table-column text="Reporter" />

				<app-table-column text="Reported on" />

			</app-table-head>

			<app-table-body>

				<app-table-row :selected="isSelected(item.id)" v-on:click="onEditClick(item.id)" :success="item.winner" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label :text="$constants.checkout.report.statusName[item.status]" :type="$constants.checkout.report.statusTheme[item.status]" :subtext="item.reference" />

					<app-table-cell-item type="organisation/library/game" :item="item.game" />

					<app-table-cell-item type="convention/badge" :item="item.badge" empty-text="Not set." />
					
					<app-table-cell-text :text="item.date | localDate('MM/DD/YYYY h:mma')" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			filter: {
				status: [],
				from: 0,
				to: 0
			},
			layout: '120px minmax(0, 1fr) minmax(0, 1fr) 180px',
			endpoint: 'convention/checkout/reports',
			live: 'convention/checkout/reports',
			edit: 'Convention.Checkout.Reports.Edit',
			filterStatus: [
				{ value: 1, text: 'Pending', theme: 'red' },
				{ value: 2, text: 'Confirmed', theme: 'yellow' },
				{ value: 3, text: 'Resolved', theme: 'green' },
				{ value: 4, text: 'Closed', theme: 'blue' }
			]
		}

	},

	computed: {
		
		importexportData: function() {

			return {
				columns: {
					'reference': 'Reference',
					'status': 'Status',
					'gameReference': 'Game Reference',
					'gameName': 'Game Name',
					'gameVersion': 'Game Version',
					'badgeReference': 'Badge Reference',
					'badgeName': 'Badge Name',
					'date': 'Report Date',
					'text': 'Report Text'
				},
				requiredColumns: [],
				valueMapping: {},
				params: this.getParams(),
				index: this.selectedIndex,
				endpoint: this.endpoint
			}

		}
	
	}

}

</script>

<style scoped>

</style>